<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.customername" @keyup.enter.native="clicksearch" placeholder="请输入客户名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.lianxifangshi" @keyup.enter.native="clicksearch" placeholder="请输入联系方式" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickexcel()">导出Excel</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel" ></TencentyunCosUploadExcel>
            注意：此处是覆盖导入
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border :cell-style="{padding: '0'}">
          <el-table-column prop="Id" label="客户编号" width="80"></el-table-column>
          <el-table-column prop="Customername" label="客户名称" width="300"></el-table-column>
          <el-table-column prop="Lianxifangshi" label="联系方式" width="200"></el-table-column>
          <el-table-column prop="Bankaccount" label="银行账号" width="200"></el-table-column>
          <el-table-column prop="Bankname" label="开户行" width="200"></el-table-column>
          <el-table-column prop="Salesmanname" label="托管销售人员" width="200"></el-table-column>
          <el-table-column prop="Gendanmanname" label="跟单员" width="200"></el-table-column>
          <el-table-column prop="Teamname" label="所属团队" width="200"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" width="300"></el-table-column>
          <el-table-column prop="Amountmin" label="最低预存金额" width="150"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" width="200"></el-table-column>
          <el-table-column prop="operation" label="操作" width="200" fixed="right">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加客户信息" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm" label="托管销售人员">
          <el-select v-model="addForm.salesmanid" placeholder="请选择" class="select" filterable>
            <el-option
              v-for="item in SalesManList" :key="item.Id" :label="item.Manname" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="跟单员">
          <el-select v-model="addForm.gendanmanid" placeholder="请选择" class="select" filterable>
            <el-option
              v-for="item in SalesManList" :key="item.Id" :label="item.Manname" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="客户名称">
          <el-input v-model="addForm.customername"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="联系方式">
          <el-input v-model="addForm.lianxifangshi"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="银行账号">
          <el-input v-model="addForm.bankaccount"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="开户行">
          <el-input v-model="addForm.bankname"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm" label="备注">
          <el-input v-model="addForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <el-tab-pane label="修改" name="three" disabled="disabled">
      <Erp6SaleBaseCustomerInfoEdit ref="SubVuethree" v-on:triggerFunc="BackToFirst"></Erp6SaleBaseCustomerInfoEdit>
    </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import Erp6SaleBaseCustomerInfoEdit from '@/componentsSubVue/Erp6SaleBaseCustomerInfoEdit.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel,
    Erp6SaleBaseCustomerInfoEdit
  },
  name: 'MyErp6SaleBaseCustomerInfo',
  data () {
    return {
      activeName: 'first',
      SalesManList:[],
      addForm: {
        salesmanid: '',
        gendanmanid: '',
        customername: '',
        lianxifangshi: '',
        bankaccount: '',
        bankname: '',
        beizhu: ''
      },
      // 查询
      keywords: {
        customername: '',
        lianxifangshi: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetErp6SaleBaseCustomerInfoNum()
    this.apiGetErp6SaleBaseCustomerInfoList()

    this.apiGetErp6SaleBaseSalespersonListAll()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp6SaleBaseCustomerInfoList()
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportErp6SaleBaseCustomerInfo(url)
    },
    clickexcel () {
      this.apiExcelErp6SaleBaseCustomerInfo()
    },
    clickadd () {
      this.apiAddErp6SaleBaseCustomerInfo()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiJiGou(row.Id)
      })
    },
    clickEdit (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row,this.SalesManList)
    },
    clickDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelErp6SaleBaseCustomerInfo(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetErp6SaleBaseCustomerInfoNum()
      this.apiGetErp6SaleBaseCustomerInfoList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6SaleBaseCustomerInfoList()
    },
    //为下拉框获取数据源-销售人员
    apiGetErp6SaleBaseSalespersonListAll: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseSalespersonListAll, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.SalesManList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetErp6SaleBaseCustomerInfoNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseCustomerInfoNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6SaleBaseCustomerInfoList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseCustomerInfoList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp6SaleBaseCustomerInfo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.addForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp6SaleBaseCustomerInfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SaleBaseCustomerInfoNum()
            that.apiGetErp6SaleBaseCustomerInfoList()

            // 清空添加
            that.addForm.name = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelErp6SaleBaseCustomerInfo: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelErp6SaleBaseCustomerInfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SaleBaseCustomerInfoNum()
            that.apiGetErp6SaleBaseCustomerInfoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelErp6SaleBaseCustomerInfo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelErp6SaleBaseCustomerInfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImportErp6SaleBaseCustomerInfo: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportErp6SaleBaseCustomerInfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetErp6SaleBaseCustomerInfoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}
.select1{
    width: 113px;
    margin-right: 15px;
}
/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
/deep/ .el-table .cell {
  white-space: pre-line;
}
</style>
